import { Modal, Radio } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Wrapper from "../../../common/component/Wrapper";
import useGetRateCodeInventorydelivery from "./useGetRateCodeInventorydelivery";

const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
};

const RenderInventoryDeliveryType = ({
    dataInventory = 1,
    onChangeInventoryType = () => { },
    supplierProductCode = '',
    isDisabled,
    error = ""
}) => {
    //! Define
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [inventoryType, setInventoryType] = useState(dataInventory);
    const [status] = useGetRateCodeInventorydelivery(supplierProductCode);
    //! useEffect
    useEffect(() => {
        setInventoryType(dataInventory);
    }, [dataInventory])

    const onReplaceinventoryTypeChange = e => {
        setInventoryType(e.target.value);
    }

    const DeliveryType = () => {
        const title = () => {
            switch (inventoryType) {
                case 1:
                    return "Mỗi ngày trong lịch trình"
                case 2:
                    return "Ngày đầu và ngày cuối lịch trình"
                case 3:
                    return "Mỗi đêm trong lịch trình"
                case 4:
                    return "Ngày đầu lịch trình"
                default:
                    return "Chọn phương thức xuất kho"
            }

        }

        return (
            <Wrapper>
                {
                    status ?
                        <>
                            <button className={`select-supplier-method-item`} disabled={isDisabled} onClick={() => { setShowModal(true) }} >{title()}</button>
                            {error && <p className="err-input-number-add-new-schedule" >{error}</p>}
                        </>
                        :
                        <button className="select-supplier-method-item" disabled={true}>NaN</button>

                }

            </Wrapper>
        )
    }

    return (
        <Fragment>
            <DeliveryType />
            <Modal title={'Lựa chọn phương thức xuất kho'}
                width={800}
                visible={showModal}
                onOk={() => { onChangeInventoryType(inventoryType); setShowModal(false) }}
                onCancel={() => {
                    setInventoryType(0);
                    setShowModal(false);
                }}
                maskClosable={false}
            >
                <Radio.Group onChange={onReplaceinventoryTypeChange} value={inventoryType} >
                    <Radio style={radioStyle} value={1}>{t(`item.ratecode.product.inventoryDeliveryTypes.EachDaySchedule`)}</Radio>
                    <Radio style={radioStyle} value={2}>{t(`item.ratecode.product.inventoryDeliveryTypes.FirstAndLastSchedule`)}</Radio>
                    <Radio style={radioStyle} value={3}>{t(`item.ratecode.product.inventoryDeliveryTypes.EachNightSchedule`)}</Radio>
                    <Radio style={radioStyle} value={4}>{t(`item.ratecode.product.inventoryDeliveryTypes.FirstDaySchedule`)}</Radio>
                </Radio.Group>
            </Modal >
        </Fragment >

    )
}

export default RenderInventoryDeliveryType